/**
 * Inline "Uitgelicht" toggle for the highlighted datatables.
 *
 * Posts the new state to the switch's data-url and deliberately does NOT reload
 * the table, so an editor can turn several items off and they stay visible
 * (dimmed) until the page is refreshed. Delegated on document so it survives
 * DataTable redraws.
 */
$(document).on('change', '.js-highlight-toggle', function () {
    const $input = $(this);
    const checked = $input.is(':checked');

    $input.prop('disabled', true);

    $.post($input.data('url'))
        .done(() => $input.closest('tr').toggleClass('opacity-40', !checked))
        .fail(() => $input.prop('checked', !checked)) // revert on error
        .always(() => $input.prop('disabled', false));
});
